export default "__VITE_ASSET__B7AK5GLk__"